import { Provider } from '@angular/core';

import { QuotesApiService } from './quotes-api.service';
import { QuotesHttpService } from './quotes-http.service';

/** Registra la implementación de `QuotesApiService` que usa la app. */
export function provideQuotes(): Provider[] {
  return [{ provide: QuotesApiService, useClass: QuotesHttpService }];
}
